import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { PalletUiRow } from '../types/palletTable.types'

export const palletTableColumns: ColumnDefinition<PalletUiRow>[] = [
  {
    key: 'Pallete_Type',
    title: 'מזהה',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pallete_Desc',
    title: 'תיאור משטח',
    dataType: 'string',
    width: '180px',
    sortable: true,
    editable: true,
    visible: true,
    required: true,
    cellRendererType: 'text',
  },
  {
    key: 'SupplierID',
    title: 'ספק',
    dataType: 'number',
    width: '200px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Main_PalleteID',
    title: 'משטח ראשי',
    dataType: 'number',
    width: '140px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Accessory1',
    title: 'אביזר 1',
    dataType: 'number',
    width: '140px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Accessory2',
    title: 'אביזר 2',
    dataType: 'number',
    width: '140px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Accessory3',
    title: 'אביזר 3',
    dataType: 'number',
    width: '140px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Catalog_Number',
    title: 'מספר קטלוגי',
    dataType: 'string',
    width: '130px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pallete_Price',
    title: 'מחיר',
    dataType: 'float',
    width: '90px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Real_Pallete',
    title: 'משטח ממשי',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Tare_Weight',
    title: 'משקל טרה',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Cooling_Fee',
    title: 'דמי קירור',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Usage_Fee',
    title: 'דמי שימוש',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'DepositWithVAT',
    title: 'פיקדון כולל מעמ',
    dataType: 'boolean',
    width: '130px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Download_from_Warehouse',
    title: 'פריקה ממחסן',
    dataType: 'boolean',
    width: '120px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Growers_Pallete',
    title: 'משטח גדלים',
    dataType: 'boolean',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Inventory',
    title: 'מלאי',
    dataType: 'boolean',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Transportation_Fee',
    title: 'דמי הובלה',
    dataType: 'boolean',
    width: '110px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Tranzit_Fee',
    title: 'דמי מעבר',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
]
